import cn from 'classnames'
import * as React from 'react'
import { Icon } from '../icon'
import Typography from '../typography/Typography'
import styles from './Indicator.module.css'
import { StepPosition, StepProps, StepState } from './MultiStepProcessIndicator.types'

export function Indicator({ value, title, className, position, state, link, ...rest }: StepProps) {
  const isActive = state === StepState.Current || state === StepState.Complete
  const isLeftTrackActive = state === StepState.Complete || state === StepState.Current
  const isRightTrackActive = state === StepState.Complete

  const content = (
    <>
      <div className={cn(styles.status, { [styles.statusActive]: isActive })}>
        {state !== StepState.Complete && <Typography variant="body-s-bold-tight">{value}</Typography>}
        {state === StepState.Complete && <Icon glyph="CheckMarkExtraSmall" size={24} />}
      </div>
      <Typography className={styles.title} variant="body-xs-regular-tight">{title}</Typography>
      <div className={cn(styles.statusBar, { [styles.statusBarActive]: isActive })} />
    </>
  )

  return (
    <div className={cn(styles.container, className)} {...rest}>
      {position !== StepPosition.First && (
        <div className={cn(styles.track, styles.leftTrack, { [styles.trackActive]: isLeftTrackActive })} />
      )}
      {link
        ? (
            <a className={styles.link} href={link.href} target={link.target} title={link.title}>
              {content}
            </a>
          )
        : (content)}
      {position !== StepPosition.Last && (
        <div className={cn(styles.track, styles.rightTrack, { [styles.trackActive]: isRightTrackActive })} />
      )}
    </div>
  )
}
